// todo: update date before release
export const PROJECT_INSTANT_VOICE_PRESETS_RELEASE_DATE = '2024-07-09T08:59:14.127698Z';
